<template>
  <div class="card" ref="chartArea7">
    <div class="CH_Card_content">
      <CButtons
        :dButtons1="select_1"
        :dButtons1_current="select_1_default"
        @Cbtns_sep="select1Change"
        style="margin-left: 0" />
      <div
        style="
          margin-left: auto;
          margin-right: 0;
          font-size: 16px;
          color: var(--primary-color);
          cursor: pointer;
        "
        @click="back">
        >>返回多指标概览
      </div>
    </div>
    <div class="CH_Card_content">
      <CCascader
        ref="type_r"
        :options="type_r_list"
        :default="r_type"
        @CCascader_select_val="fnCCascader_type_r"
        :checkStrictly="true"
        :multiple="false"
        :isDelete="false"
        :middle="true"
        takeOut="takeOut"
        :collapsetags="true"
        >选择类别
      </CCascader>
      <CCascader
        v-if="code_list.length"
        ref="CCascader2_chart1"
        style="margin-left: 20px"
        @CCascader_select_val="fnSelect_codes"
        :default="code"
        :options="code_list"
        :checkStrictly="false"
        :multiple="true"
        :isDelete="false"
        :wide="true"
        :collapsetags="true">
        选择对比REITs
      </CCascader>
      <CSelect
        v-if="factor_name_list.length"
        class="chart3_cascasder"
        style="margin-left: 20px"
        @CSelect_select_val="change_factor"
        :options="factor_name_list"
        :clearable="false"
        :middle="true"
        :default="factor_default">
        指标选择
        <template #tooltip="{ item }">
          <el-tooltip effect="dark" placement="right" v-if="factor_maps[item.value]">
            <template #content>
              <div style="width: 15vw" v-html="factor_maps[item.value]"></div>
            </template>
            <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
          </el-tooltip>
        </template>
      </CSelect>
      <CSelect
        class="chart3_cascasder"
        @CSelect_select_val="change_graphic_type_val"
        :options="graphic_types"
        :clearable="false"
        :mini="true"
        :default="graphic_type_value">
      </CSelect>
      <span class="oneyear">
        <el-checkbox @change="takeCheck" v-model="checked_one"></el-checkbox>
        只显示整体
      </span>
    </div>
    <div class="down-wrap" style="display: flex">
      <Download
        echartRefName="chartColumn"
        :dButtonsDownloads="dButtonsDownloads"
        :excel_info="excel_info" />
      <MultipleSheetsXlsxDownload
        style="margin-left: 10px"
        @download-before="handlDownload"
        v-bind.sync="sheets_info"
        >多指标表格</MultipleSheetsXlsxDownload
      >
    </div>
    <span @click="fnOpenDialog" class="iconfont icon-fangda icon-fangda2"></span>
    <div class="echarts_area CHARTS_BGC">
      <div
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        id="chartColumn"
        ref="chartColumn"
        style="width: 100%; height: 700px"></div>
      <div class="area_tips" v-if="factor_default == 'eff_discount'">
        <i class="el-icon-question" style="color: #409eff"></i>
        如果实际租金于披露折扣率超过100%,一般是由于实际租金中包含纯租金以外的科目包括，未能识别的增值税、物业管费、其它部分如配套商铺、停车场等部分的收入折算到主体面积上。
      </div>
    </div>
    <div
      style="
        margin: 0 calc(var(--ROOTFONTFIZE) * (30 / 144));
        margin-bottom: -20px;
        margin-top: calc(var(--ROOTFONTFIZE) * (30 / 144));
        color: var(--table_color);
      ">
      <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
      下面为蓝色的数字表示为根据指标定义中的计算公式自动推算数据
    </div>
    <div class="table_case">
      <el-table
        ref="tableList"
        :data="source_data"
        :header-cell-style="tableStyle"
        @cell-click="fnClick"
        @cell-mouse-leave="hiddenTipsPop(false)">
        <el-table-column label="代码" width="140" fixed>
          <template slot-scope="scope">
            {{ scope.row.reit_code }}
          </template>
        </el-table-column>
        <el-table-column label="简称" width="140" fixed>
          <template slot-scope="scope">
            {{ scope.row.reit_name }}
          </template>
        </el-table-column>
        <el-table-column label="资产名称" width="140" fixed>
          <template slot-scope="scope">
            {{ scope.row.asset_name }}
          </template>
        </el-table-column>
        <el-table-column label="入住率类型" align="center" width="160" v-if="str_flag">
          <template slot-scope="scope">
            {{ scope.row.occ_type }}
          </template>
        </el-table-column>
        <el-table-column
          :label="item"
          width="170"
          sortable
          :prop="item"
          v-for="(item, index) in chartColumn_X"
          :key="index"
          align="center">
          <template slot-scope="scope">
            <!--             <el-popover
              v-if="
                (r_type === '产业园' || r_type === '物流仓储') && select_1_default === '财务报告'
              "
              :close-delay="100"
              placement="top"
              width="160"
              v-model="scope.row[item + '_popover_visible']"
              trigger="hover">
              <p>是否查看:{{ scope.row.reit_name }}{{ item }}原始财报？</p>
              <div style="text-align: right; margin-top: 20px">
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    scope.row[item + '_popover_visible'] = false;
                    showIframe(scope);
                  "
                  >查看</el-button
                >
              </div>
              <span slot="reference" :class="getTipsFlag2(scope.row, item)">
                {{ addThousandSeparator(colNumType2(scope.row[item])) }}
                <i
                  v-if="scope.row[item]"
                  class="el-icon-search"
                  style="font-size: 12px !important; color: var(--primary-color)"></i>
              </span>
            </el-popover> -->
            <span
              :class="getTipsFlag2(scope.row, item)"
              @mouseenter="showTipsPop(scope, item, $event)">
              {{ addThousandSeparator(colNumType2(scope.row[item])) }}
              <i
                v-if="showHtmlTips && select_1_default === '财务报告' && scope.row[item]"
                class="el-icon-search"
                style="font-size: 12px !important; color: var(--primary-color)"></i>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <CDialog
      id="dialog1"
      ref="CDialog"
      :DIALOGHEIGHT="height_dialog"
      :dialogVisible="dialogVisible">
      <el-dialog
        title="葱花投研"
        :visible.sync="dialogVisible"
        :width="width_dialog"
        :top="top_dialog">
        <div>
          <el-dropdown size="mini" trigger="click" type="primary" @command="fnDropdown">
            <span class="el-dropdown-link">
              {{ popUpWindowDatas[popUpWindowIndex]
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="idx" v-for="(node, idx) in popUpWindowDatas" :key="idx">
                {{ node }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div :style="{ height: height_chart }">
          <div ref="chartRefDialog" style="width: 100%; height: 100%"></div>
          <div class="d_area_tips" v-if="factor_default == 'eff_discount'">
            <i class="el-icon-question" style="color: #409eff"></i>
            如果实际租金于披露折扣率超过100%,一般是由于实际租金中包含纯租金以外的科目包括，未能识别的增值税、物业管费、其它部分如配套商铺、停车场等部分的收入折算到主体面积上。
          </div>
        </div>
      </el-dialog>
    </CDialog>
    <CDialog
      id="dialog115654"
      ref="CDialog54"
      DIALOGHEIGHT="75vh"
      :dialogVisible="show_iframe_dialog">
      <el-dialog title="葱花投研" :visible.sync="show_iframe_dialog" width="65vw" top="5vh">
        <div v-html="iframe_content" style="width: 100%; height: 100%"></div>
      </el-dialog>
    </CDialog>
    <div
      role="tooltip"
      id="el-popover-8544"
      aria-hidden="true"
      class="el-popover el-popper"
      tabindex="0"
      :style="{
        width: '160px',
        'transform-origin': 'center bottom',
        'z-index': 20,
        position: 'fixed',
        ...popperStyle,
      }"
      @mouseenter="hiddenTipsPop(true)"
      @mouseleave="hiddenTipsPop(false)">
      <p>是否查看{{ dialog_info.name }}{{ dialog_info.period }}原始财报？</p>
      <div style="text-align: right; margin-top: 20px">
        <button
          type="button"
          class="el-button el-button--primary el-button--mini"
          @click="showIframe(dialog_info.code, dialog_info.period)">
          <span>查看</span>
        </button>
      </div>
      <div x-arrow class="popper__arrow" style="left: 80px"></div>
    </div>
  </div>
</template>

<script>
import CButtons from '@/components/Basic/CButtons_separate.vue';
import CCascaderK from '@/components/Basic/CCascaderK';
import CCascader from '@/components/Basic/CCascader';
import CSelect from '@/components/Basic/CSelect';
import CDialog from '@/components/Basic/CDialog';
import Download from '@/components/Basic/Download';
import MultipleSheetsXlsxDownload from '@/components/Basic/MultipleSheetsXlsxDownload';
import { fnReturnTableStyle } from '@/utils/util';
import { getGradientColor, normalize, taskStack } from '@/utils';

// 批量任务 单线程
const callTask = taskStack(3);

export default {
  name: 'Operation',
  props: {
    select_tag: String,
    g_r_type: String,
  },
  components: {
    CCascaderK,
    CCascader,
    CSelect,
    CDialog,
    Download,
    MultipleSheetsXlsxDownload,
    CButtons,
  },
  data() {
    return {
      dialog_info: {
        name: '',
        code: '',
        period: '',
      },
      popperStyle: {
        left: '-200vw',
        top: '-200vh',
      },
      iframe_content: '',
      show_iframe_dialog: false,
      select_1: ['财务报告', '运营报告'],
      select_1_default: '财务报告',
      checked_one: false,
      OFFSETHEIGHT: 0,
      str_flag: false,
      source_data: [],
      factor_maps: {},
      sheets_info: {
        loading: false,
        file_name: '',
      },
      //
      col_num_type: '',
      chart_title: '',
      table_td: [],
      table_th: [],
      excel_info: {
        excel_data: [],
        json_fields: {
          代码: 'asset_name',
          简称: 'reit_code',
          资产名称: 'reit_name',
        },
        overviewName: '投资者持股比例',
      },
      dButtonsDownloads: [
        {
          id: '241047',
          name: '下载图片',
        },
        {
          id: '241047',
          name: '下载表格',
        },
      ],

      graphic_type_value: 'line',
      graphic_types: [
        {
          value: 'line',
          label: '折线',
        },
        {
          value: 'bar',
          label: '柱状',
        },
      ],
      factor_default: '',
      factor_name_list: [],
      code: [],
      code_list: [],
      r_type: '交通设施',
      type_r_list: [
        {
          value: '产权类',
          label: '产权类',
          disabled: true,
          children: [
            {
              value: '物流仓储',
              label: '物流仓储',
            },
            {
              value: '产业园',
              label: '产业园',
            },
            {
              value: '租赁住房',
              label: '租赁住房',
            },
            {
              value: '消费',
              label: '消费',
            },
            {
              value: '数据中心',
              label: '数据中心',
            },
          ],
        },
        {
          value: '经营权类',
          label: '经营权类',
          disabled: true,
          children: [
            // {
            //   value: '市政生态',
            //   label: '市政生态',
            // },
            {
              value: '能源',
              label: '能源',
            },
            {
              value: '交通设施',
              label: '交通设施',
            },
          ],
        },
        {
          value: '公募REITs',
          label: '公募REITs',
          disabled: true,
        },
      ],

      echart_dialog_instance: null,
      chartColumn: null,
      chartColumn_X: [],
      chartColumn_Y_list: [],

      sCurrentTheme: this.$store.state.theme == 'dark' ? true : false,
      ROOTFONTFIZE: 0,
      TABPANEHEIGHT: 0,

      dialogVisible: false,
      width_dialog: '80%',
      height_dialog: '73vh',
      height_chart: '72vh',
      popUpWindowDatas: this.$store.state.popUpWindowDatas,
      popUpWindowIndex: 0,
      top_dialog: '5vh',

      //20250815
      tips_map: {},
      tips_map2: {},
      tips_map_flag: null,
    };
  },
  methods: {
    hiddenTipsPop(flag) {
      if (this.tpid) {
        clearTimeout(this.tpid);
      }
      if (flag) return;
      this.tpid = setTimeout(() => {
        this.popperStyle = {
          left: `${0}px`,
          top: `${0}px`,
          transform: `translate(-50%, -105%)`,
        };
      }, 100);
    },
    showTipsPop(scope, k, e) {
      this.dialog_info = {
        name: scope.row.reit_name,
        code: scope.row.reit_code,
        period: k,
      };
      if (this.showHtmlTips && this.select_1_default === '财务报告' && scope.row[k]) {
        if (this.tpid) {
          clearTimeout(this.tpid);
        }
        const { left, top, width } = e.target.getBoundingClientRect();
        this.popperStyle = {
          left: `${left + width / 2}px`,
          top: `${top}px`,
          transform: `translate(-50%, -105%)`,
        };
      }
    },
    async showIframe(code, rp_period) {
      if (this.ifarme_lock) return;
      // const code = row.reit_code;
      // const rp_period = column.label;
      this.ifarme_lock = true;
      const { data } = await this.$https.get(
        `/api/v4/single_operation_html?code=${code}&rp_period=${rp_period}`
      );
      if (data.code !== 200) {
        this.ifarme_lock = false;
        return this.$message.error(data.msg);
      }

      const blob = new Blob([data.data.display_html], { type: 'text/html' });
      const blobUrl = URL.createObjectURL(blob);
      this.iframe_content = `<iframe src="${blobUrl}" style="width: 100%; height: 100%" frameborder="0"  tabindex="0"></iframe>`;

      this.show_iframe_dialog = true;

      setTimeout(() => {
        this.ifarme_lock = false;
        URL.revokeObjectURL(blobUrl);
      }, 1000);
    },
    back() {
      this.$emit('changePage', 'OperationOverviews');
    },
    select1Change(v) {
      this.select_1_default = v;
      this.$nextTick(() => {
        this.get_operation_data_button();
      });
    },
    getXlsxData(factor_name) {
      const api_url = {
        财务报告: '/api/v4/get_operation_data_all',
        运营报告: '/api/v2_5/get_operation_data_all_midterm',
      }[this.select_1_default];
      let only_zt = this.checked_one ? 1 : 0;
      let codes = this.code.join('&codes=');
      return this.$https.get(
        `${api_url}?r_type=${this.r_type}&category_2=${this.r_type}&codes=${codes}&factor_name=${factor_name}&only_zt=${only_zt}`
      );
    },
    handlDownload(cb) {
      if (this.no_data) {
        this.$message.warning(this.no_data);
        return;
      }
      this.sheets_info.loading = true;
      const factor_name_list = this.factor_name_list.map(({ value }) => value);
      Promise.all(factor_name_list.map((k) => callTask(() => this.getXlsxData(k)))).then(
        (result) => {
          const xlsx_data = [];
          result.forEach(({ data }) => {
            // 显示错误信息
            if (data.code !== 200) {
              this.$message.error(data.msg);
            } else {
              //留下成功的请求;
              xlsx_data.push(data.data);
            }
          });
          const fields_map = {
            asset_name: '代码',
            reit_code: '简称',
            reit_name: '资产名称',
            occ_type: '入住率类型',
          };
          const excel_info = xlsx_data.map((item) => {
            item.data = item.data || [];
            const fields = Object.keys(item.data[0] || {}).reduce((p, c) => {
              p[c] = fields_map[c] || c;
              return p;
            }, {});
            return {
              data: item.data,
              fields,
              name: item.col_name,
            };
          });
          this.sheets_info = {
            loading: true,
            file_name: this.r_type + '-多指标数据',
            excel_info: Object.freeze(excel_info),
          };
          cb();
          setTimeout(() => {
            this.sheets_info.loading = false;
          }, 300);
        }
      );
    },
    colNumType2(node) {
      if (node === '') return '';
      if (this.col_num_type == 'pct' && node === 0) {
        return (Number(node) * 100).toFixed(2) + '%';
      }
      if (this.col_num_type == 'num4') {
        node = Number(node).toFixed(4);
      }
      if (this.col_num_type == 'num2') {
        node = Number(node).toFixed(2);
      }
      if (this.col_num_type == 'pct') {
        node = (Number(node) * 100).toFixed(2) + '%';
      }
      return node;
    },
    fnClick(row, column, cell, event) {
      const { reit_name, reit_code } = row;
      const { label } = column;
      if (['代码', '简称', '资产名称'].includes(label)) {
        let arr = [reit_name, reit_code];
        this.$eventBus.$emit('skipPage', arr);
      }
    },
    addThousandSeparator(str) {
      if (!str) {
        return str;
      }
      // 校验输入是否为有效数字字符串（允许逗号、小数点和负号）
      const isValid = /^-?(?:\d{1,3}(?:,\d{3})*|\d+)(?:\.\d+)?$/.test(str);
      if (!isValid) return str;
      if (typeof str == 'number') {
        str = str + '';
      }
      // 移除原有逗号，避免重复处理
      const cleanedStr = str.replace(/,/g, '');
      const [integerPart, decimalPart] = cleanedStr.split('.');

      // 添加千分位分隔符
      const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;
    },
    handleClick() {
      // console.log('handleClick');
      this.get_operation_data_button();
    },
    fnOpenDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.fnGetchartColumn(true);
      });
    },
    fnDropdown(val) {
      let conf = this.$store.state.popUpWindowConfi[val];
      this.width_dialog = conf.width_dialog;
      this.top_dialog = conf.top_dialog;
      this.height_dialog = conf.height_dialog;
      this.popUpWindowIndex = val;
      this.height_chart = conf.height_chart;
      this.$nextTick(() => {
        this.fnGetchartColumn(true);
      });
    },
    takeCheck() {
      this.$nextTick(() => {
        this.fnGetchartColumn();
      });
    },
    fnSelect_codes(val) {
      this.code = val;
      this.fnGetchartColumn();
    },
    fnCCascader_type_r(val) {
      this.r_type = val;
      this.get_operation_data_button();
    },
    change_factor(val) {
      this.factor_default = val;
      this.fnGetchartColumn();
    },
    change_graphic_type_val(val) {
      this.graphic_type_value = val;
      this.fnGetchartColumn();
    },
    async get_operation_data_button() {
      const report_type = {
        财务报告: 'quarterly',
        运营报告: 'midterm',
      }[this.select_1_default];
      const { data } = await this.$https.get(
        `/api/v4/get_operation_data_button?category_2=${this.r_type}&report_type=${report_type}`
      );

      if (data.code !== 200) return this.$message.error(data.msg);
      this.factor_maps = Object.freeze(data.data.factor_maps || {});
      this.code_list = [];
      this.code = [];
      var CODEobj = JSON.parse(localStorage.getItem('CODEobj'));
      data.data.codes.forEach((item) => {
        this.code_list.push({
          value: item,
          label: CODEobj[item],
        });
        this.code.push(item);
      });
      if (this.$refs.CCascader2_chart1) {
        this.$refs.CCascader2_chart1.value = this.code;
      }
      this.factor_name_list = [];
      this.factor_default = '';
      var obj_list = Array.from(Object.entries(data.data.factor_names), ([key, val]) => ({
        key,
        val,
      }));
      obj_list.forEach((item) => {
        this.factor_name_list.push({
          value: item.key,
          label: item.val,
        });
      });
      if (this.factor_name_list.length > 0) {
        const value = this.select_tag ? this.select_tag : this.factor_name_list[0].value;
        this.factor_default = value;
        this.$emit('update:select_tag', '');
      }
      this.$nextTick(() => {
        this.fnGetchartColumn();
      });
    },

    async fnGetchartColumn(flag) {
      this.echart_dialog_instance && this.echart_dialog_instance.dispose();
      this.echart_dialog_instance = null;
      this.chartColumn && this.chartColumn.dispose();
      this.chartColumn = null;
      // let r_type = this.type_r.join('&r_type=');
      let codes = this.code.join('&codes=');
      let factor_name = this.factor_default;
      let only_zt = this.checked_one ? 1 : 0;
      const api_url = {
        财务报告: '/api/v4/get_operation_data_all',
        运营报告: '/api/v2_5/get_operation_data_all_midterm',
      }[this.select_1_default];
      const { data } = await this.$https.get(
        `${api_url}?r_type=${this.r_type}&category_2=${this.r_type}&codes=${codes}&factor_name=${factor_name}&only_zt=${only_zt}`
      );
      if (data.code !== 200) return this.$message.error(data.msg);
      if (!data.data.data.length) {
        this.no_data = data.msg;
        this.$message.warning(data.msg);
        this.excel_info.excel_data = [];
        return;
      }
      data.data.data.forEach((item) => {
        Object.keys(item).forEach((key) => {
          item[`${key}_popover_visible`] = false;
        });
      });
      this.no_data = null;
      this.tips_map = {};
      this.source_data = data.data.data;
      this.tips_map_flag = data.data.mask_label;
      const mask_label = data.data.mask_label !== 'all' ? data.data.mask_label || [] : [];
      mask_label.forEach((item) => {
        const { reit_code, reit_name, asset_name, ...new_item } = item;
        const sortedKeys = Object.keys(new_item).sort();
        const sortedObj = {};
        sortedKeys.forEach((key) => (sortedObj[key] = new_item[key]));
        const sort_list = Object.values(sortedObj);
        this.tips_map[item.asset_name] = [reit_code, reit_name, asset_name, ...sort_list];
        this.tips_map2[item.asset_name] = item;
      });

      this.chart_title = data.data.col_name;
      this.col_num_type = data.data.col_num_type;
      if (data.data.data.length < 1) {
        return;
      }
      if (Object.keys(data.data.data[0]).indexOf('occ_type') != -1) {
        this.str_flag = true;
      }
      this.chartColumn_X = Object.keys(data.data.data[0]).filter((item) => {
        const flag1 = ['asset_name', 'reit_code', 'reit_name', 'occ_type'].includes(item);
        const flag2 = item.indexOf('popover_visible') === -1;
        return !flag1 && flag2;
      });
      this.chartColumn_Y_list = [];
      data.data.data.forEach((item) => {
        var one = Array.from(Object.entries(item), ([key, val]) => ({ key, val }));
        var one_list = [];
        one.forEach((item2) => {
          if (
            item2.key != 'asset_name' &&
            item2.key != 'reit_code' &&
            item2.key != 'reit_name' &&
            item2.key != 'occ_type'
          ) {
            one_list.push(item2.val);
          }
        });
        this.chartColumn_Y_list.push({
          // asset_name: item.asset_name != '整体' ? item.asset_name : item.reit_name + '-整体',
          asset_name: item.asset_name,
          reit_code: item.reit_code,
          reit_name: item.reit_name,
          occ_type: item.occ_type,
          list: one_list,
        });
      });

      this.table_th = ['代码', '简称', '资产名称', ...this.chartColumn_X];
      this.table_year = this.chartColumn_X;
      if (this.str_flag) {
        this.table_th = ['代码', '简称', '资产名称', '入住率类型', ...this.chartColumn_X];
      }
      this.table_td = [];
      this.chartColumn_Y_list.forEach((item) => {
        if (this.str_flag) {
          this.table_td.push([
            item.reit_code,
            item.reit_name,
            item.asset_name,
            item.occ_type,
            ...item.list,
          ]);
        } else {
          this.table_td.push([item.reit_code, item.reit_name, item.asset_name, ...item.list]);
        }
      });
      this.excel_info.overviewName = this.r_type + ' - ' + this.chart_title;
      this.excel_info.excel_data = data.data.data;
      this.excel_info.json_fields = {
        代码: 'asset_name',
        简称: 'reit_code',
        资产名称: 'reit_name',
      };
      if (this.str_flag) {
        this.excel_info.json_fields = {
          代码: 'asset_name',
          简称: 'reit_code',
          资产名称: 'reit_name',
          入住率类型: 'occ_type',
        };
      }
      this.chartColumn_X.forEach((item) => {
        this.excel_info.json_fields[item] = item;
      });
      this.$nextTick(() => {
        this.initChartColumn(flag);
      });
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.tableList.bodyWrapper.scrollLeft = Number(
            this.$refs.tableList.bodyWidth.replace('px', '')
          );
        }, 1000); // 延迟时间通常需要1秒以上
      });
    },

    initChartColumn(flag) {
      if (flag && !this.echart_dialog_instance) {
        this.echart_dialog_instance = this.$echarts.init(this.$refs.chartRefDialog);
      }
      if (!this.chartColumn) {
        this.chartColumn = this.$echarts.init(this.$refs.chartColumn);
      }
      let col_num_type = this.col_num_type;
      let chartColumn_X = this.chartColumn_X;
      let chartColumn_Y_list = this.chartColumn_Y_list;
      // console.log('chartColumn_Y_list', chartColumn_Y_list);

      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      let color = this.$store.state.colors.filter((item) => item.name === this.r_type)[0]['value'];

      var series_list = [];
      var icon_list = [];
      var index = 0;
      var asset_name_map = {};
      chartColumn_Y_list.forEach((item) => {
        icon_list.push({
          name: item.reit_name + '-' + item.asset_name,
          lineStyle: {
            width: 10,
          },
        });
        asset_name_map[item.asset_name] = item.reit_name;
        series_list.push({
          name: item.reit_name + '-' + item.asset_name,
          type: this.graphic_type_value,
          data: item.list,
          itemStyle: {
            color: getGradientColor(normalize(index, chartColumn_Y_list.length, 0), [
              color,
              this.$store.state.theme == 'dark' ? '#FFF' : '#7d818a',
            ]),
          },
          emphasis: {
            disabled: true,
            // focus: 'series',
          },
          label: {
            show: false,
            position: 'inside',
            fontSize: this.ROOTFONTFIZE * (14 / 144),
            color: '#fefefe',
          },
        });
        index++;
      });

      let option = {
        toolbox: {
          // 工具箱按钮
          right: 20,
          top: 10,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
        // 标题设置
        title: [
          {
            text: this.r_type + ' - ' + this.chart_title,
            textStyle: {
              // 标题文字样式设置
              color: OPTIONDATA.title.textStyle.color,
              fontSize: OPTIONDATA.title.textStyle.fontSize,
            },
            left: 'center',
            top: OPTIONDATA.title.top,
          },
        ],
        legend: {
          show: true,
          orient: 'vertical',
          top: this.ROOTFONTFIZE * (50 / 144),
          right: this.ROOTFONTFIZE * (20 / 144),
          top: this.ROOTFONTFIZE * (100 / 144),
          align: 'left',
          icon: 'roundRect',
          itemGap: 5,
          itemHeight: 5,
          height: 400,
          padding: [0, 0, 0, 0],
          type: 'scroll',
          pageIconColor: 'blue',
          pageIconInactiveColor: OPTIONDATA.legend.textStyle.color,
          pageTextStyle: {
            color: OPTIONDATA.legend.textStyle.color,
          },
          lineStyle: {
            color: 'inherit',
          },
          textStyle: {
            color: OPTIONDATA.legend.textStyle.color,
            fontSize: OPTIONDATA.legend.textStyle.fontSize,
            width: this.ROOTFONTFIZE * (180 / 144),
            overflow: 'break',
          },
          data: icon_list,
        },

        grid: {
          left: this.ROOTFONTFIZE * (20 / 144),
          bottom: this.ROOTFONTFIZE * (60 / 144),
          right: this.ROOTFONTFIZE * (250 / 144),
          top: this.ROOTFONTFIZE * (80 / 144),
          containLabel: true,
        },
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove|click',
          formatter: (args) => {
            const { seriesName, value, name } = args;
            let val = value;
            if (col_num_type == 'pct') {
              val = (Number(val) * 100).toFixed(2) + '%';
            }
            return `<div>${name}</div>
                    <div>${seriesName}: ${val}</div>
                    `;
          },
        },

        xAxis: {
          type: 'category',
          data: chartColumn_X,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff',
            },
            onZero: true, //轴线是否在0刻度轴上
          },

          axisTick: {
            show: true,
          },
          axisLabel: {
            interval: 0,
            fontSize: OPTIONDATA.xAxis.axisLabel.fontSize,
            margin: OPTIONDATA.xAxis.axisLabel.margin,
            rotate: 45,
            show: true,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
          },
        },
        yAxis: [
          {
            // scale: true,
            position: 'left',
            type: 'value',
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
              //x轴刻度相关设置
              alignWithLabel: true,
            },
            axisLabel: {
              fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
              show: true,
              color: OPTIONDATA.yAxis.axisLabel.color,
              // formatter: "{value}%", //y轴百分比
              formatter: function (val) {
                if (col_num_type == 'pct') {
                  val = Number(val) * 100 + '%';
                }
                return val;
              },
            },
            splitLine: OPTIONDATA.yAxis.splitLine,
          },
        ],
        series: series_list,
      };
      if (flag) {
        this.echart_dialog_instance.setOption(option);
        this.echart_dialog_instance.resize();
        // return;
      }
      this.chartColumn.setOption(option);
      this.chartColumn.resize();
    },

    styleBindFun() {
      let val = this.$store.state.theme == 'dark' ? true : false;
      this.theme = this.$store.state.theme;
      return fnReturnTableStyle(val);
    },
    funResize() {
      this.chartColumn && this.chartColumn.resize();
      this.fnGetWidth();
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;

      let OFFSETHEIGHT = element.offsetHeight;
      this.TABPANEHEIGHT = OFFSETHEIGHT - 135;
      return;
    },
    getTipsFlag2(row, idx) {
      if (this.tips_map_flag === 'all') {
        return 'blue';
      }
      return this.tips_map2[row['asset_name']] &&
        this.tips_map2[row['asset_name']][idx] === 1 &&
        this.tips_map2[row['asset_name']][idx] !== 0
        ? 'blue'
        : '';
    },
  },
  created() {
    if (this.g_r_type) {
      this.r_type = this.g_r_type;
    }
  },
  computed: {
    showHtmlTips() {
      const r_type = this.r_type;
      return ['消费', '租赁住房', '产业园', '物流仓储', '能源', '数据中心'].includes(r_type);
    },
    table1_width() {
      var width =
        this.ROOTFONTFIZE * (220 / 144) * 2 +
        this.ROOTFONTFIZE * (150 / 144) * (this.table_th.length - 2);

      return 'width:' + width + 'px;!important;';
    },
    table1_height() {
      var height = this.ROOTFONTFIZE * (50 / 144) * (this.table_td.length - 2);

      return height;
    },
    cssVars() {
      return {
        '--ROOTFONTFIZE': this.ROOTFONTFIZE + 'px',
        '--TABPANEHEIGHT': this.TABPANEHEIGHT + 'px',
      };
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
      // return fnReturnTableStyle(val);
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      this.styleBindFun();
      this.$nextTick(() => {
        this.initChartColumn();
      });
    },
  },
  mounted() {
    window.addEventListener('resize', this.funResize);
    this.fnGetWidth();
    this.handleClick();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.funResize);
    this.chartColumn && this.chartColumn.dispose();
  },
};
</script>

<style scoped lang="less">
/deep/#el-popover-8544 {
  .popper__arrow {
    transform: rotate(180deg) translateY(-12px) !important;
    &::after {
      display: none;
    }
  }
}

.CButtonsSeparate_style {
  // margin-left: calc(var(--ROOTFONTFIZE) * (20 / 144));
  margin-left: 20px;
}

.CH_Card_content {
  display: flex;
  align-items: center;
  margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding: 0 calc(var(--ROOTFONTFIZE) * (20 / 144));
  position: relative;
}
.down-wrap {
  width: 97%;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
}

.icon-fangda2 {
  position: absolute;
  right: 125px;
  top: 190px;
}

.table_area {
  margin: 0 calc(var(--ROOTFONTFIZE) * (30 / 144));
  overflow-x: auto !important;
  &::-webkit-scrollbar {
    width: calc(var(--ROOTFONTFIZE) * (6 / 144));
    height: calc(var(--ROOTFONTFIZE) * (12 / 144));
    // background-color: #0e1d35;
  }

  &::-webkit-scrollbar-thumb {
    background-color: gray;
  }
}

table {
  border: none;
  margin-top: calc(var(--ROOTFONTFIZE) * (30 / 144));
  border-bottom: 1px solid var(--table_brc);
  padding-right: calc(var(--ROOTFONTFIZE) * (50 / 144));
}

.table_first {
  border-bottom: calc(var(--ROOTFONTFIZE) * (2 / 144)) solid var(--table_brc) !important;
  border-top: calc(var(--ROOTFONTFIZE) * (2 / 144)) solid var(--table_brc) !important;
  background-color: var(--table_th_bgc) !important;
  td:nth-child(1) {
    background-color: var(--table_th_bgc) !important;
  }
}

th {
  padding: calc(var(--ROOTFONTFIZE) * (15 / 144)) calc(var(--ROOTFONTFIZE) * (20 / 144));
  font-size: calc(var(--ROOTFONTFIZE) * (18 / 144));
  font-weight: 700;
  letter-spacing: 0.21px;
  line-height: calc(var(--ROOTFONTFIZE) * (16.76 / 144));
  color: var(--table_color);
  text-align: center;
  width: calc(var(--ROOTFONTFIZE) * (150 / 144));
}
th:nth-child(1),
th:nth-child(2),
th:nth-child(3) {
  position: sticky;
  left: 0;
  background-color: var(--table_th_bgc) !important;
  // width: calc(var(--ROOTFONTFIZE) * (170 / 144));
  text-align: left;
}
th:nth-child(1) {
  // width: calc(var(--ROOTFONTFIZE) * (150 / 144));
}
th:nth-child(2) {
  width: calc(var(--ROOTFONTFIZE) * (220 / 144)) !important;
  left: calc(var(--ROOTFONTFIZE) * (140 / 144));
}
th:nth-child(3) {
  width: calc(var(--ROOTFONTFIZE) * (220 / 144));
  left: calc(var(--ROOTFONTFIZE) * (270 / 144));
}

.table_main {
  width: auto;
  background-color: var(--table_bgc);
  padding: 0;
  border-bottom: 1px solid var(--table_brc);
}

.table_main:hover {
  background-color: var(--table_bgc_hover);
  td:nth-child(1),
  td:nth-child(2),
  td:nth-child(3) {
    background-color: var(--table_bgc_hover);
  }
}
.table_main:nth-child(1) {
  background-color: var(--table_bgc_hover) !important;
}

tr {
  line-height: calc(var(--ROOTFONTFIZE) * (15 / 144));
  // padding: 0 !important;
}
tr:last-child {
  border-bottom: none !important;
}

td {
  width: calc(var(--ROOTFONTFIZE) * (150 / 144));
  text-align: center;
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
  letter-spacing: 0px;
  color: var(--table_color);
  padding: calc(var(--ROOTFONTFIZE) * (10 / 144)) calc(var(--ROOTFONTFIZE) * (20 / 144));
  line-height: 1.3;
}

td:nth-child(1),
td:nth-child(2),
td:nth-child(3) {
  position: sticky;
  left: 0;
  // width: calc(var(--ROOTFONTFIZE) * (170 / 144));
  text-align: left;
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
  font-weight: 700;
  // line-height: 10px;
  color: var(--table_color);
  padding: calc(var(--ROOTFONTFIZE) * (15 / 144)) calc(var(--ROOTFONTFIZE) * (20 / 144));
  background-color: var(--table_bgc);
}
td:nth-child(1) {
  // width: calc(var(--ROOTFONTFIZE) * (150 / 144)) !important;
}
td:nth-child(2) {
  width: calc(var(--ROOTFONTFIZE) * (220 / 144)) !important;
  left: calc(var(--ROOTFONTFIZE) * (140 / 144));
}
td:nth-child(3) {
  width: calc(var(--ROOTFONTFIZE) * (220 / 144)) !important;
  left: calc(var(--ROOTFONTFIZE) * (270 / 144));
}

// table end --------------------------------------------------------------------

.area_tips {
  position: absolute;
  top: 660px;
  left: 30px;
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  color: var(--table_color);
  span {
    color: #00aec7;
  }
}
.d_area_tips {
  position: absolute;
  width: 73%;
  bottom: 30px;
  left: 30px;
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  color: var(--table_color);
  span {
    color: #00aec7;
  }
}
.blue {
  color: #00aec7 !important;
}
.table_case {
  width: 100%;
  box-sizing: border-box;
  padding: 0 calc(var(--ROOTFONTFIZE) * (30 / 144));
}
.el-table {
  padding-bottom: 0 !important;
}
/deep/ .el-table table {
  border: none !important;
}
/deep/ .el-table__fixed::before {
  background-color: transparent !important;
}
.oneyear {
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  color: var(--table_color);
}
</style>
